import React from 'react';
import '../styles.css';

export default function CanalDenuncias() {
  return (
    <section className="canal-denuncias" id="canal-denuncias">
      <div className="container">
        <h1>Canal de Denúncias</h1>
        <p>
          A <strong>Amaratech</strong> mantém este canal de comunicação como parte do seu compromisso
          com a ética, a transparência e o cumprimento das leis e regulamentos aplicáveis.
        </p>
        <p>
          Aqui você pode relatar, de forma <strong>segura e confidencial</strong>, qualquer conduta que
          viole nossos princípios éticos, políticas internas ou a legislação vigente.
        </p>
        <p>
          O envio da denúncia é simples e pode ser feito de forma <strong>anônima</strong>. 
          Garantimos total sigilo e proteção das informações prestadas.
        </p>

        <a
          href="https://forms.office.com/Pages/ResponsePage.aspx?id=Ec7fIckPzkO6N6hNQUzOAO5XTlBcPTdIgGXevJfN95dUOFpJUVRGRFJHRlJIWVBQVDZHUE8zRTVFUy4u"
          target="_blank"
          rel="noopener noreferrer"
          className="denuncia-btn"
        >
          Acessar Formulário de Denúncia
        </a>

        <div className="lgpd-aviso">
          <p>
            🔒 As informações fornecidas neste canal serão tratadas em conformidade com a 
            <strong> Lei nº 13.709/18 (Lei Geral de Proteção de Dados Pessoais - LGPD)</strong>, 
            garantindo confidencialidade, integridade e segurança dos dados.
          </p>
        </div>
      </div>
    </section>
  );
}
